// 初期表示
export const PAGE_INIT = "corp/overview/PAGE_INIT";

// 役員情報取得
export const PROFILE_GET = "corp/overview/PROFILE_GET";
